// opens the faq row selected from the index after a short delay to allow time for scrolling to it
$('.faq-entry a').click(function() {
  let target = $(this).attr('href');
  console.log(target);
  setTimeout(function(){
    $(target + ' input').prop('checked', true);
  }, 220);
});

// closes all open faq rows
$('.faq-close').click(function() {
  $('.expanding-toggle').each(function() {
    $(this).prop('checked', false);
    $(this).attr('aria-expanded', 'false')
  });
});

// shows/hides 'back to index' button on FAQ page/where FAQ index is present
function faqIndexReturn() {
  if (window.innerWidth < 750 && document.querySelector('.faq-index-return')) {
    let faqIndex = document.getElementById('faq-content');
    let faqReturn = document.querySelector('.faq-index-return');
    let content = 800; // fallback offset in case of function error
    let pageScrolled = false;
    let aboveContent = true;
    let belowContent = false;
    window.addEventListener('scroll', function() {
      if (pageScrolled == false && window.scrollY > 0) {
        pageScrolled = true;
        content = faqIndex?.offsetTop;
        console.log('bottom of index is: ' + content);
        content += 100;
        console.log('with final buffer: ' + content);   
      } else if (belowContent == false && window.scrollY > content) {
        aboveContent = false;
        belowContent = true;
        faqReturn.classList.remove('visually-hidden');
        setTimeout(() => {
          faqReturn.style.setProperty('opacity', '1');
        }, 50);
      } else if (aboveContent == false && window.scrollY < content) {
        aboveContent = true;
        belowContent = false;
        faqReturn.style.setProperty('opacity', '0');
        setTimeout(() => {
          faqReturn.classList.add('visually-hidden');
        }, 350);
      }
    });
  }
}
faqIndexReturn();
// the only time we need to automatically recheck the offsets on resize is when moving above and below desktop breakpoint, so we set a media query and add a listener for when it changes to run the function
const mqd = window.matchMedia('(max-width: 749px)');
mqd.addEventListener('change', (e) => faqIndexReturn());